import type { IAPComponentTypes } from '@play-co/components/frontend';

type PaymentMethod = IAPComponentTypes.Options.PurchaseMethod;

/**
 * Order of payment methods in the UI (AB test)
 * ordered according to unique usage - https://app.amplitude.com/analytics/playco/chart/nmw9355s
 */
export const orderV2Android: PaymentMethod[] = [
  'komoju_paypay',
  'komoju_docomo',
  'komoju_aupay',
  'komoju_credit_card',
  'komoju_softbank',
  'stripe_googlePay',
  'komoju_au',
  'komoju_rakutenpay',
  'atone_lite',
  'atone_bnpl',
];

export const orderV2iOS: PaymentMethod[] = [
  'komoju_paypay',
  'komoju_aupay',
  'komoju_docomo',
  'stripe_applePay',
  'komoju_credit_card',
  'komoju_rakutenpay',
  'komoju_softbank',
  'komoju_au',
  'atone_bnpl',
  'atone_lite',
  'stripe_googlePay',
];
